export type OrderStatus =
  | "received"
  | "sent"
  | "delivered"
  | "collected"
  | "refoundInProgress"
  | "refoundAccepted"
  | "refoundRejected"
  | "cancelled"
  | "editOrderPendingPayment"

export const getStatusLabel = (status: OrderStatus) => {
  switch (status) {
    case "received":
      return "In preparazione"
    case "delivered":
      return "Consegnato"
    case "collected":
      return "Ritirato"
    case "sent":
      return "Spedito"
    case "refoundInProgress":
      return "Reso in corso"
    case "refoundAccepted":
      return "Reso completato"
    case "refoundRejected":
      return "Reso rifiutato"
    case "cancelled":
      return "Annullato"
    case "editOrderPendingPayment":
      return "Pagamento in sospeso"
    default:
      return ""
  }
}
